import { styled } from 'styled-components';
import { palette } from '@/constants/styles';

const Button = styled.button<{ $size?: 'small' | 'normal'; $color?: 'primary' | 'danger' }>`
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	height: ${({ $size }) => ($size === 'small' ? '28px' : '30px')};
	line-height: ${({ $size }) => ($size === 'small' ? '28px' : '30px')};
	border: solid 1px
		${({ $color }) =>
			$color === 'primary' ? palette.primaryColor : $color === 'danger' ? palette.dangerColor : '#dbdbdb'};
	border-radius: 4px;
	background-color: ${({ $color }) =>
		$color === 'primary' ? palette.primaryColor : $color === 'danger' ? palette.dangerColor : 'white'};
	font-size: 14px;
	font-weight: 300;
	color: ${({ $color }) => ($color === 'primary' || $color === 'danger' ? 'white' : 'black')};
	padding: 0 0.5rem;

	&:hover {
		border: solid 1px ${palette.primaryColor};
		cursor: pointer;
	}

	&:disabled {
		opacity: 0.5;
		cursor: auto;
	}
`;

export default Button;
